import { EXPENSE_TYPES_ACTIONS } from 'store/v1/expense_types/expense_types.constants.js';
import { AUTH_ACTIONS } from 'store/v1/auth/auth.constants.js';

export const INITIAL_STATE = {
  data: {},
  paging: {},
  order: [],
  loading: false,
  fetched: false
};

export default function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case EXPENSE_TYPES_ACTIONS.GET_EXPENSE_TYPES:
    case EXPENSE_TYPES_ACTIONS.CREATE_EXPENSE_TYPE:
    case EXPENSE_TYPES_ACTIONS.UPDATE_EXPENSE_TYPE:
    case EXPENSE_TYPES_ACTIONS.UPDATE_EXPENSE_TYPE_ORDER:
    case EXPENSE_TYPES_ACTIONS.DELETE_EXPENSE_TYPE:
      return {
        ...state,
        loading: action.type,
        error: false
      };
    case AUTH_ACTIONS.LOAD_AUTH_SUCCESS: {
      const { expense_types = [] } = action.result;
      return {
        ...state,
        data: expense_types.reduce(
          (data, item) => ({ ...data, [item.id]: item }),
          {}
        ),
        order: expense_types.map(item => item.id),
        loading: false,
        fetched: true
      };
    }
    case EXPENSE_TYPES_ACTIONS.GET_EXPENSE_TYPES_SUCCESS:
      return {
        ...state,
        data: action.result.results.reduce(
          (data, item) => ({ ...data, [item.id]: item }),
          {}
        ),
        order: action.result.results.map(item => item.id),
        paging: action.result.paging,
        loading: false,
        fetched: true
      };
    case EXPENSE_TYPES_ACTIONS.UPDATE_EXPENSE_TYPE_ORDER_SUCCESS:
      return {
        ...state,
        data: action.result.reduce(
          (data, item) => ({ ...data, [item.id]: item }),
          {}
        ),
        order: action.result.map(item => item.id),
        loading: false
      };
    case EXPENSE_TYPES_ACTIONS.UPDATE_EXPENSE_TYPE_SUCCESS:
      return {
        ...state,
        data: {
          ...state.data,
          [action.result.id]: action.result
        },
        loading: false
      };
    case EXPENSE_TYPES_ACTIONS.CREATE_EXPENSE_TYPE_SUCCESS:
      return {
        ...state,
        data: { ...state.data, [action.result.id]: action.result },
        order: [...state.order, action.result.id],
        loading: false
      };
    case EXPENSE_TYPES_ACTIONS.DELETE_EXPENSE_TYPE_SUCCESS:
      return {
        ...state,
        data: {
          ...state.data,
          [action.id]: {
            ...state.data[action.id],
            archived: true
          }
        },
        order: state.order.filter(id => id !== action.id),
        loading: false
      };
    case EXPENSE_TYPES_ACTIONS.GET_EXPENSE_TYPES_FAILURE:
    case EXPENSE_TYPES_ACTIONS.UPDATE_EXPENSE_TYPE_FAILURE:
    case EXPENSE_TYPES_ACTIONS.CREATE_EXPENSE_TYPE_FAILURE:
    case EXPENSE_TYPES_ACTIONS.DELETE_EXPENSE_TYPE_FAILURE:
    case EXPENSE_TYPES_ACTIONS.UPDATE_EXPENSE_TYPE_ORDER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      };
    default:
      return state;
  }
}
